
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import ImageSlider1 from "@/components/content-management/image-slider/ImageSlider1.vue";
import ImageSlider2 from "@/components/content-management/image-slider/ImageSlider2.vue";
import ImageSlider4 from "@/components/content-management/image-slider/ImageSlider4.vue";

@Component({
  components: {
    ImageSlider4,
    ImageSlider1,
    ImageSlider2,
  },
  filters,
})
export default class ImageSlider extends Vue {
  @Prop({ default: 1 })
  private templateNumber!: number;
  @Prop({ default: null })
  private section!: any;
}
